<template>
    <div class="AccessControl" v-loading.fullscreen.lock="fullscreenLoading" :style="{ height: Height - 105 + 'px'}">
        <el-container :style="{ height: Height - 105 + 'px'}">
            <el-header height="80px">
                <el-row>
                    <el-col>
                        <h2>门禁管理</h2>
                    </el-col>
                    <el-col :span="12" style="text-align: left; padding-left: 10px;">
                        <el-popover
                            placement="bottom-start"
                            width="400"
                            trigger="manual"
                            v-model="visible">
                            <el-form ref="ruleForms" :model="queryform" label-width="100px">
                                <el-form-item label="公司名称">
                                    <el-input v-model="queryform.keyword"></el-input>
                                </el-form-item>
                                <el-form-item label="房间号">
                                    <el-input v-model="queryform.room"></el-input>
                                </el-form-item>
                            </el-form>
                            <el-row>
                                <el-col style="text-align: right;">
                                    <el-button type="primary" @click="Reset">重置</el-button>
                                    <el-button type="primary" @click="ConfirmQuery">确认</el-button>
                                </el-col>
                            </el-row>
                            <el-button type="primary" slot="reference" @click="visible = !visible">查询</el-button>
                        </el-popover>
                    </el-col>
                    <el-col :span="12">
                        <!-- <el-button type="primary" @click="AddAccessControl">新增</el-button> -->
                        <el-button type="primary" @click="AccessControlLogShow">门禁日志</el-button>
                    </el-col>
                </el-row>
            </el-header>
            <el-main>
                <el-table :height="Height - 265" :data="tableData" border style="width: 100%">
                    <el-table-column prop="UID" label="门禁ID">
                    </el-table-column>
                    <el-table-column prop="title" label="门禁号">
                    </el-table-column>
                    <el-table-column prop="remark" label="备注" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="address" label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="EditAccessControl(scope.row)">编辑</el-button>
                            <el-button type="text" @click="DelAccessControl(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-dialog :title="title" :visible.sync="AccessControl" top="7vh" width="700px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" custom-class="AccessControl">
                    <el-form :model="form" ref="ruleForm" label-width="120px">
                        <el-form-item label="门禁ID" prop="UID">
                            <el-input v-model="form.UID" :disabled="true"></el-input>
                        </el-form-item>
                        <el-form-item label="门禁号" prop="title">
                            <el-input v-model="form.title"></el-input>
                        </el-form-item>
                        <el-form-item label="备注" style="display: block; width: 100%;">
                            <el-input type="textarea" v-model="form.remark"></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="AccessControl = false">取 消</el-button>
                        <el-button type="primary" @click="SaveAccessControl" :loading="confirmloding">确 定</el-button>
                    </div>
                </el-dialog>
                <el-dialog title="门禁日志" :visible.sync="AccessControlLogShowDialog" top="7vh" width="1000px" :close-on-click-modal="false" :close-on-press-escape="false" custom-class="AccessControlLogShowDialog">
                    <el-row>
                        <el-col>
                            <el-popover
                                placement="bottom-start"
                                width="400"
                                trigger="manual"
                                v-model="visibles">
                                <el-form ref="ruleForms" :model="queryforms" label-width="100px">
                                    <el-form-item label="门禁ID" prop="UID">
                                        <el-select v-model="queryforms.UID" placeholder="请选择门禁ID">
                                            <el-option
                                            v-for="item in tableData"
                                            :key="item.id"
                                            :label="item.title"
                                            :value="item.UID">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="类别" prop="type">
                                        <el-select v-model="queryforms.type" placeholder="请选择类别">
                                            <el-option
                                            label="门禁二维码"
                                            value="Q">
                                            </el-option>
                                            <el-option
                                            label="门禁卡"
                                            value="C">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="开始时间" prop="dDateS">
                                        <el-date-picker
                                            v-model="queryforms.dDateS"
                                            type="datetime"
                                            placeholder="选择开始时间"
                                            default-time="7:00:00" value-format="yyyy-MM-dd HH:mm:ss">
                                        </el-date-picker>
                                    </el-form-item>
                                    <el-form-item label="结束时间" prop="dDateE">
                                        <el-date-picker
                                            v-model="queryforms.dDateE"
                                            type="datetime"
                                            placeholder="选择结束时间"
                                            default-time="23:00:00" value-format="yyyy-MM-dd HH:mm:ss">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-form>
                                <el-row>
                                    <el-col style="text-align: right;">
                                        <el-button type="primary" @click="Reset">重置</el-button>
                                        <el-button type="primary" @click="ConfirmQuerys">确认</el-button>
                                    </el-col>
                                </el-row>
                                <el-button type="primary" slot="reference" @click="visibles = !visibles">查询</el-button>
                            </el-popover>
                        </el-col>
                    </el-row>
                    <el-table v-loading="loading" :height="Height - 300" :data="AccessControlLogList" border style="width: 100%">
                        <el-table-column prop="UID" label="门禁ID">
                        </el-table-column>
                        <el-table-column prop="user_name" label="使用人">
                        </el-table-column>
                        <el-table-column prop="opentime" label="开门时间" show-overflow-tooltip>
                        </el-table-column>
                        <!-- <el-table-column prop="address" label="操作">
                            <template slot-scope="scope">
                                <el-button type="text" @click="EditAccessControl(scope.row)">编辑</el-button>
                                <el-button type="text" @click="DelAccessControl(scope.row)">删除</el-button>
                            </template>
                        </el-table-column> -->
                    </el-table>
                    <div slot="footer" class="dialog-footer">
                        <el-row>
                            <el-col :span="6" style="text-align: left;">
                                <el-pagination
                                    @size-change="handleSizeChanges"
                                    @current-change="handleCurrentChanges"
                                    :current-page="queryforms.page"
                                    :page-sizes="[10, 20, 50, 100]"
                                    :page-size="queryforms.limit"
                                    layout="total"
                                    :total="queryforms.total">
                                </el-pagination>
                            </el-col>
                            <el-col :span="12" style="text-align: center;">
                                <el-pagination
                                    @size-change="handleSizeChanges"
                                    @current-change="handleCurrentChanges"
                                    :current-page="queryforms.page"
                                    :page-sizes="[10, 20, 50, 100]"
                                    :page-size="queryforms.limit"
                                    layout="prev, pager, next"
                                    :total="queryforms.total">
                                </el-pagination>
                            </el-col>
                            <el-col :span="6">
                                <el-pagination
                                    @size-change="handleSizeChanges"
                                    @current-change="handleCurrentChanges"
                                    :current-page="queryforms.page"
                                    :page-sizes="[10, 20, 50, 100]"
                                    :page-size="queryforms.limit"
                                    layout="->, sizes"
                                    :total="queryforms.total">
                                </el-pagination>
                            </el-col>
                        </el-row>
                        <!-- <el-button @click="AccessControlLogShowDialog = false">取 消</el-button>
                        <el-button type="primary" @click="SaveAccessControl" :loading="confirmloding">确 定</el-button> -->
                    </div>
                </el-dialog>
            </el-main>
            <el-footer>
                <el-row>
                    <el-col :span="6">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="total"
                            :total="total">
                        </el-pagination>
                    </el-col>
                    <el-col :span="12" style="text-align: center;">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="prev, pager, next"
                            :total="total">
                        </el-pagination>
                    </el-col>
                    <el-col :span="6">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="->, sizes"
                            :total="total">
                        </el-pagination>
                    </el-col>
                </el-row>
            </el-footer>
        </el-container>
  </div>
</template>

<script>
/*eslint-disable */
import { getToken, getAdminId } from "../../../utils/auth";
import https from "../../../utils/http";
export default {
    name: "AccessControl",
    data () {
        return {
            url: https.http,
            visible: false,
            fullscreenLoading: false,
            tableData: [],
            AccessControl: false,
            form: {
                title: '',
                contact: '',
                tel: '',
                contact1: '',
                tel1: '',
                remark: '',
                img: [],
                intro: '',
                room: '',
                status: 1
            },
            title: '',
            currentPage: 1,
            Size: 20,
            total: 1,
            visible: false,
            queryform: {
                keyword: '',
                remark: ''
            },
            Uploaddata: {
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            },
            http: https.https,
            preview: false,
            fileList: [],
            confirmloding: false,
            AccessControlLogShowDialog: false,
            AccessControlLogList: [],
            queryforms: {
                UID: '',
                type: '',
                dDateS: '',
                dDateE: '',
                limit: 20,
                page: 1,
                total: 0
            },
            loading: false,
            visibles: false
        }
    },
    mounted() {

    },
    watch: {

    },
    methods: {
        handleSizeChange(size) {
            this.Size = size
            this.currentPage = 1
            this.fullscreenLoading = true
            this.GetAccessControlList(this.queryform.keyword, this.queryform.room)
        },
        handleCurrentChange(page) {
            this.currentPage = page
            this.fullscreenLoading = true
            this.GetAccessControlList(this.queryform.keyword, this.queryform.room)
        },
        handleSizeChanges(size) {
            this.queryforms.limit = size
            this.queryforms.page = 1
            this.loading = true
            this.GetAccessControlLogList()
        },
        handleCurrentChanges(page) {
            this.queryforms.page = page
            this.loading = true
            this.GetAccessControlLogList()
        },
        GetAccessControlList (keyword, room) {
            let data = {
                keyword: this.queryform.keyword,
                remark: this.queryform.remark,
                limit: this.Size,
                page: this.currentPage,
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            }
            this.$store.dispatch('AccessControlListShow', data).then(res => {
                this.fullscreenLoading = false
                this.total = res.something
                console.log(res.data)
                this.tableData = res.data
                // this.form = {
                //     title: '',
                //     remark: '',
                // }
                this.visible = false
            })
        },
        Reset () {
           this.$refs['ruleForms'].resetFields();
           this.queryform = {
                keyword: '',
                room: ''
            }
        },
        ConfirmQuery() {
            this.currentPage = 1
            this.GetAccessControlList(this.queryform.keyword, this.queryform.room)
        },
        ConfirmQuerys () {
            this.queryforms.page = 1
            this.GetAccessControlLogList()
        },
        SaveAccessControl() {
            let that = this
            let data = JSON.parse(JSON.stringify(this.form))
            data.ADMIN_ID = getAdminId();
            data.ADMIN_TOKEN = getToken();
            // data.img = JSON.stringify(this.form.img)
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    this.confirmloding = true
                    that.$store.dispatch('SaveAccessControl', data).then(res => {
                        that.confirmloding = false
                        if (res.flag) {
                            that.$message({
                                message: res.message,
                                type: 'success'
                            })
                            that.AccessControl = false
                            that.fullscreenLoading = true
                            that.GetAccessControlList(that.queryform.keyword, that.queryform.room)
                        } else {
                            that.$message({
                                message: res.message,
                                type: 'warning'
                            })
                        }
                    })
                } else {
                    // that.$message({
                    //     message: '请先填写必填项',
                    //     type: 'error'
                    // })
                    return false;
                }
            });
            
        },
        EditAccessControl(row) {
            this.AccessControl = true
            this.title = '编辑门禁'
            this.form = JSON.parse(JSON.stringify(row))
            // this.fileList = JSON.parse(this.form.img)
            // this.form.img = JSON.parse(this.form.img)
        },
        DelAccessControl(row) {
            this.$confirm('是否删除该门禁？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                row.ADMIN_ID = getAdminId();
                row.ADMIN_TOKEN = getToken();
                this.$store.dispatch('DelAccessControl', row).then(res => {
                     if (res.flag) {
                        this.$message({
                            message: res.message,
                            type: 'success'
                        })
                        this.fullscreenLoading = true
                        this.GetAccessControlList(this.queryform.keyword, this.queryform.room)
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'warning'
                        })
                    }
                })
            }).catch(() => {
            })
        },
        GetAccessControlLogList() {
            let data = {
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken(),
                UID: this.queryforms.UID,
                type: this.queryforms.type,
                dDateS: this.queryforms.dDateS,
                dDateE: this.queryforms.dDateE,
                limit: this.queryforms.limit,
                page: this.queryforms.page
            }
            this.$store.dispatch('AccessControlLogListShow', data).then(res => {
                // this.fullscreenLoading = false
                this.visibles = false
                this.queryforms.total = res.something
                this.loading = false
                this.AccessControlLogList = res.data
            })
        },
        Reset () {
            this.queryforms = {
                UID: '',
                type: '',
                dDateS: '',
                dDateE: '',
                limit: 20,
                page: 1
            }
        },
        AccessControlLogShow () {
            this.AccessControlLogShowDialog = true
            this.loading = true
            this.GetAccessControlLogList()
        }
    },
    created() {
        this.fullscreenLoading = true
        this.GetAccessControlList()
    },
    computed: {
        Height() {
            return this.$store.state.loginModule.Height;
        }
    }
}
</script>

<style>
.AccessControl {
    width: 100%;
}
.AccessControl .el-header .el-row .el-col {
    height: 40px;
    line-height: 40px;
}
.AccessControl .el-header .el-row .el-col h2 {
    text-align: center;
}
.AccessControl .el-header .el-row .el-col {
    text-align: center;
}
.AccessControl .el-header .el-row .el-col:last-child {
    text-align: right;
}
.AccessControl .el-main {
    padding-top: 0px;
    padding-bottom: 0px;
}
.AccessControl .el-main .AccessControl .el-dialog__body {
    padding-top: 0px;
    padding-bottom: 0px;
}
.AccessControl .el-main .AccessControlLogShowDialog .el-dialog__body {
    padding-top: 5px;
}
.AccessControl .el-main .AccessControlLogShowDialog .el-dialog__body .el-row {
    margin-bottom: 10px;
}
/* .AccessControl .el-main .AccessControl .el-dialog__body .el-form-item {
    display: inline-block;
    width: 50%;
} */
</style>
